import { WbLink, WbText } from '@workbench/react';
import { useTranslation } from 'react-i18next';

import './VimdtProductKey.scss';

/**
 * Prompts for a Product-Key while the tab's `apikey` input is still empty.
 */
function VimdtProductKey({ apikey }) {
	const { t } = useTranslation();

	if (apikey) return null;

	return (
		<div className="vimdt-product-key">
			<WbText size="l">
				<b>{t('vimdt.mainScreen.producstKeyNeeded')}</b> {t('vimdt.mainScreen.purchaseThem')}{' '}
				<WbLink
					href="https://developer.mercedes-benz.com/products?u=Retailer"
					rel="noopener noreferrer"
					target="_blank"
					variant="inline"
				>
					Mercedes-Benz /developers
				</WbLink>{' '}
				{t('vimdt.mainScreen.portal')}.
			</WbText>
		</div>
	);
}

export default VimdtProductKey;
